import React, { useEffect, useState } from "react";
import api from "../../../../api";
import { useParams } from "react-router-dom";

const GanttChartTab = () => {
 const { id: projectId } = useParams();
 const [data, setData] = useState([]);
 const [loading, setLoading] = useState(true);

 const fetchGantt = async () => {
 try {
 const res = await api.get(`/gantt-chart/${projectId}`);
 if (res.data.success) {
 // Format backend data into UI format
 const formatted = res.data.data.map((g) => ({
 group: g.group || "Unnamed Group",
 task: g.task || "Untitled Task",
 remarks: g.remarks || "",
 subs: (g.subs || []).map((s) => ({
 task: s.task || "Sub Task",
 start: s.start || null,
 end: s.end || null,
 remarks: s.remarks || ""
 }))
 }));

 setData(formatted);
 } else {
 setData([]);
 }
 } catch (err) {
 console.error("Gantt Fetch Error:", err);
 setData([]);
 } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 if (projectId) fetchGantt();
 }, [projectId]);

 const formatDate = (d) => (d ? new Date(d).toISOString().split("T")[0] : "—");

 const diffDays = (start, end) => {
 if (!start || !end) return 0;
 return Math.ceil((new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24)) + 1;
 };

 if (loading) return <p className="text-muted">Loading Gantt data...</p>;

 return (
 <div className="gantt-container">
 <h3 className="gantt-title">Project Gantt Overview</h3>

 {data.length === 0 && <p className="text-muted">No Gantt data available.</p>}

 {data.map((g, idx) => (
 <div key={idx} className="gantt-group">
 <div className="group-header">
 <div className="group-left">
 <div className="group-badge">{g.group[0]}</div>
 <div>
 <div className="group-title">{g.task}</div>
 {g.remarks && <div className="group-remarks">{g.remarks}</div>}
 </div>
 </div>
 </div>

 <div className="sub-container">
 {g.subs && g.subs.length > 0 ? (
 g.subs.map((s, i) => (
 <div key={i} className="sub-card">
 <div className="sub-title">{s.task}</div>

 <div className="sub-info">
 {formatDate(s.start)} → {formatDate(s.end)} ({diffDays(s.start, s.end)} days)
 </div>

 {s.remarks && <div className="sub-remarks"> {s.remarks}</div>}

 <div className="sub-bar-wrapper">
 <div
 className="sub-bar"
 style={{
 width: `${Math.min(diffDays(s.start, s.end), 30) * 3}px`
 }}
 ></div>
 </div>
 </div>
 ))
 ) : (
 <div className="no-sub">No subtasks</div>
 )}
 </div>
 </div>
 ))}
 </div>
 );
};

export default GanttChartTab;
